import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal } from 'react-bootstrap';
import { getRequest, postRequest } from '../../requestUtils';
import ResumeActions from './ResumeActions';
import Loading from '../common/Loading';
import InterestDetails from './InterestDetails';
import './ConsultantInterest.scss';
var TransferApplication = /*#__PURE__*/lazy(function () {
  return import('../common/TransferApplication');
});
var renderLogistics = function renderLogistics(daysAgo, fromOpportunity) {
  return /*#__PURE__*/React.createElement("div", {
    className: " mb-3 "
  }, fromOpportunity && /*#__PURE__*/React.createElement("span", {
    className: "badge badge-fallback-tertiary me-3 normal-font pull-right"
  }, "OpenOpps"), /*#__PURE__*/React.createElement("p", null, daysAgo));
};
var ConsultantInterest = /*#__PURE__*/function (_Component) {
  function ConsultantInterest(props) {
    var _this;
    _classCallCheck(this, ConsultantInterest);
    _this = _callSuper(this, ConsultantInterest, [props]);
    _this.state = {
      interest: props.interest,
      accepted: props.interest.accepted,
      rejected: props.interest.rejected,
      waitlisted: props.interest.waitlisted,
      project: props.project,
      showApplicationModal: false,
      showTransferModal: false
    };
    _this.setInterestAndProject = _this.setInterestAndProject.bind(_this);
    _this.handleRejectInterest = _this.handleRejectInterest.bind(_this);
    _this.handleWaitlistInterest = _this.handleWaitlistInterest.bind(_this);
    _this.handleAcceptInterest = _this.handleAcceptInterest.bind(_this);
    _this.handleShowApplicationModal = _this.handleShowApplicationModal.bind(_this);
    _this.handleCloseApplicationModal = _this.handleCloseApplicationModal.bind(_this);
    _this.handleOpenTransferModal = _this.handleOpenTransferModal.bind(_this);
    _this.handleCloseTransferModal = _this.handleCloseTransferModal.bind(_this);
    _this.createNewProposal = _this.createNewProposal.bind(_this);
    _this.isHybridOrInOffice = _this.isHybridOrInOffice.bind(_this);
    return _this;
  }
  _inherits(ConsultantInterest, _Component);
  return _createClass(ConsultantInterest, [{
    key: "setInterestAndProject",
    value: function setInterestAndProject() {
      var _this2 = this;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var _this$props = this.props,
        interest = _this$props.interest,
        interestId = _this$props.interestId,
        csrfToken = _this$props.csrfToken;
      var hasProjectDetails = interest && interest.project && interest.project.name;
      if (Object.keys(interest).length && hasProjectDetails) {
        this.setState({
          interest: interest
        }, callback);
      } else {
        getRequest("/consultant_interests/".concat(interestId), {}, csrfToken).then(function (response) {
          _this2.setState({
            interest: response.data
          }, callback);
        });
      }
    }
  }, {
    key: "createNewProposal",
    value: function createNewProposal() {
      var _this3 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        createProposalPath = _this$props2.createProposalPath;
      var interest = this.state.interest;
      var pathInfo = createProposalPath.split('?');
      var pathPost = pathInfo[0];
      var pathParams = pathInfo[1];
      var params = {
        project_id: pathParams[0].split('=')[1],
        consultant_interest_id: interest.id
      };
      postRequest(pathPost, params, csrfToken).then(function (response) {
        _this3.props.createdProposal(response.data);
      });
    }
  }, {
    key: "handleShowApplicationModal",
    value: function handleShowApplicationModal() {
      var _this4 = this;
      this.setInterestAndProject(function () {
        return _this4.setState({
          showApplicationModal: true
        });
      });
    }
  }, {
    key: "handleCloseApplicationModal",
    value: function handleCloseApplicationModal() {
      this.setState({
        showApplicationModal: false
      });
    }
  }, {
    key: "handleOpenTransferModal",
    value: function handleOpenTransferModal() {
      this.setState({
        showApplicationModal: false,
        showTransferModal: true
      });
    }
  }, {
    key: "handleCloseTransferModal",
    value: function handleCloseTransferModal() {
      this.setState({
        showTransferModal: false,
        showApplicationModal: true
      });
    }
  }, {
    key: "handleAcceptInterest",
    value: function handleAcceptInterest() {
      var acceptedCallback = this.props.acceptedCallback;
      var interest = this.state.interest;
      this.setState({
        accepted: true,
        rejected: false,
        waitlisted: false,
        showApplicationModal: false
      });
      acceptedCallback(interest);
    }
  }, {
    key: "handleWaitlistInterest",
    value: function handleWaitlistInterest() {
      var waitlistedCallback = this.props.waitlistedCallback;
      var interest = this.state.interest;
      this.setState({
        accepted: false,
        rejected: false,
        waitlisted: true,
        showApplicationModal: false
      });
      waitlistedCallback(interest);
    }
  }, {
    key: "handleRejectInterest",
    value: function handleRejectInterest() {
      var rejectedCallback = this.props.rejectedCallback;
      var interest = this.state.interest;
      interest.rejected = true;
      this.setState({
        rejected: true,
        accepted: false,
        waitlisted: false,
        showApplicationModal: false
      });
      rejectedCallback(interest);
    }
  }, {
    key: "renderInterestDetails",
    value: function renderInterestDetails() {
      var _this$props3 = this.props,
        interest = _this$props3.interest,
        clorifyUrl = _this$props3.clorifyUrl;
      return /*#__PURE__*/React.createElement("div", {
        className: "mb-2"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "fs-hide normal-weight pd-5"
      }, /*#__PURE__*/React.createElement("a", {
        href: interest.consultant_url,
        target: "_blank",
        rel: "noreferrer"
      }, interest.consultant_name), /*#__PURE__*/React.createElement("a", {
        href: clorifyUrl,
        target: "_blank",
        rel: "noreferrer"
      }, " (view Clorify)")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("button", {
        className: "primary btn btn-primary full-width",
        onClick: this.handleShowApplicationModal
      }, "View Application"));
    }
  }, {
    key: "renderShowInProposalTabButton",
    value: function renderShowInProposalTabButton() {
      return /*#__PURE__*/React.createElement("button", {
        className: "proposal-tab-review-button",
        onClick: this.handleShowApplicationModal
      }, "Review");
    }
  }, {
    key: "isHybridOrInOffice",
    value: function isHybridOrInOffice() {
      var _this$state, _this$state$interest, _this$state$interest$, _this$state$interest$2;
      var info = ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : (_this$state$interest = _this$state.interest) === null || _this$state$interest === void 0 ? void 0 : (_this$state$interest$ = _this$state$interest.project) === null || _this$state$interest$ === void 0 ? void 0 : (_this$state$interest$2 = _this$state$interest$.office_and_worktype_information) === null || _this$state$interest$2 === void 0 ? void 0 : _this$state$interest$2.toLowerCase()) || '';
      return ['hybrid', 'in office', 'onsite'].some(function (keyword) {
        return info.includes(keyword);
      });
    }
  }, {
    key: "renderTransferModal",
    value: function renderTransferModal() {
      var _this$props4 = this.props,
        csrfToken = _this$props4.csrfToken,
        projectResourceId = _this$props4.projectResourceId,
        projectsOptions = _this$props4.projectsOptions,
        interestId = _this$props4.interestId;
      var showTransferModal = this.state.showTransferModal;
      var applicationProject = projectsOptions.find(function (project) {
        return project.value === projectResourceId;
      });
      var filteredProjects = projectsOptions.filter(function (project) {
        return project.value !== projectResourceId;
      });
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, null)
      }, /*#__PURE__*/React.createElement(TransferApplication, {
        triggerText: "Move Interest to another project",
        idKey: "move-application-modal",
        selectOptions: filteredProjects,
        csrfToken: csrfToken,
        applicationType: "Consultant Interest",
        interestResourceId: String(interestId),
        applicationProject: applicationProject,
        open: showTransferModal,
        onClose: this.handleCloseTransferModal
      }));
    }
  }, {
    key: "renderApplicationModal",
    value: function renderApplicationModal() {
      var _interest$response,
        _interest$response2,
        _interest$response3,
        _this5 = this;
      var _this$props5 = this.props,
        csrfToken = _this$props5.csrfToken,
        cloraRepName = _this$props5.cloraRepName;
      var _this$state2 = this.state,
        showApplicationModal = _this$state2.showApplicationModal,
        accepted = _this$state2.accepted,
        rejected = _this$state2.rejected,
        waitlisted = _this$state2.waitlisted,
        interest = _this$state2.interest;
      var noAction = !accepted && !rejected && !waitlisted;
      return /*#__PURE__*/React.createElement(Modal, {
        dialogClassName: "consultant-interest-modal-container",
        className: "style-guide",
        show: showApplicationModal,
        onHide: this.handleCloseApplicationModal,
        size: "lg"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(InterestDetails, {
        project: interest.project,
        csrfToken: csrfToken,
        openToRelocation: (_interest$response = interest.response) === null || _interest$response === void 0 ? void 0 : _interest$response.open_to_relocation,
        location: (_interest$response2 = interest.response) === null || _interest$response2 === void 0 ? void 0 : _interest$response2.location,
        requestedHourlyRate: (_interest$response3 = interest.response) === null || _interest$response3 === void 0 ? void 0 : _interest$response3.requested_hourly_rate,
        resume: {
          document_file_name: interest.resume_name,
          document_url: interest.resume_url
        },
        isHybridOrInOffice: this.isHybridOrInOffice(),
        repView: true,
        submitted: true
      }), /*#__PURE__*/React.createElement(Row, {
        className: "mt-40"
      }, !waitlisted && !rejected && /*#__PURE__*/React.createElement(Col, {
        xs: 6
      }, /*#__PURE__*/React.createElement(ResumeActions, {
        consultant: interest.consultant_name,
        project: interest.project_name,
        formUrl: interest.update_state_url,
        interestId: interest.id,
        csrfToken: csrfToken,
        afterSubmit: this.handleWaitlistInterest,
        responseTemplates: interest.response_templates,
        key: interest.id,
        feedbackText: interest.internal_feedback_text,
        action: "Waitlist",
        addlButtonStyle: "right-align",
        cloraRepName: cloraRepName
      })), !accepted && !rejected && /*#__PURE__*/React.createElement(Col, {
        xs: 6
      }, /*#__PURE__*/React.createElement(ResumeActions, {
        consultant: interest.consultant_name,
        project: interest.project_name,
        formUrl: interest.update_state_url,
        interestId: interest.id,
        csrfToken: csrfToken,
        afterSubmit: this.handleAcceptInterest,
        responseTemplates: interest.response_templates,
        key: interest.id,
        action: "Accept",
        addlButtonStyle: waitlisted ? 'right-align' : 'left-align'
      })), !rejected && /*#__PURE__*/React.createElement(Col, {
        xs: noAction ? 12 : 6,
        className: noAction ? 'center-align' : ''
      }, noAction && /*#__PURE__*/React.createElement("div", {
        className: "mt-2"
      }), /*#__PURE__*/React.createElement(ResumeActions, {
        consultant: interest.consultant_name,
        project: interest.project_name,
        formUrl: interest.update_state_url,
        interestId: interest.id,
        csrfToken: csrfToken,
        afterSubmit: this.handleRejectInterest,
        responseTemplates: interest.response_templates,
        key: interest.id,
        rejectionReason: interest.internal_feedback_reason,
        feedbackText: interest.internal_feedback_text,
        action: "Decline"
      })), /*#__PURE__*/React.createElement(Col, {
        xs: noAction ? 12 : 6,
        className: noAction ? 'center-align' : ''
      }, noAction && /*#__PURE__*/React.createElement("div", {
        className: "mt-2"
      }), /*#__PURE__*/React.createElement("a", {
        className: "application-transfer-anchor-trigger",
        tabIndex: 0,
        role: "button",
        href: "#move-interest",
        onClick: function onClick(e) {
          e.preventDefault();
          _this5.handleOpenTransferModal();
        }
      }, "Move Interest to another project")))));
    }
  }, {
    key: "renderInterestStatus",
    value: function renderInterestStatus() {
      var _this$state3 = this.state,
        accepted = _this$state3.accepted,
        rejected = _this$state3.rejected,
        waitlisted = _this$state3.waitlisted;
      if (rejected) {
        return /*#__PURE__*/React.createElement("div", {
          className: "resume-rejected"
        }, "Resume Rejected");
      }
      return /*#__PURE__*/React.createElement("div", null, waitlisted && /*#__PURE__*/React.createElement("div", {
        className: "resume-waitlisted"
      }, "Waitlist"), accepted && /*#__PURE__*/React.createElement("div", {
        className: "resume-accepted"
      }, "Resume Accepted"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        interest = _this$props6.interest,
        showInProposalsTab = _this$props6.showInProposalsTab;
      var accepted = this.state.accepted;
      if (showInProposalsTab) {
        return /*#__PURE__*/React.createElement(Fragment, null, this.renderShowInProposalTabButton(), this.renderApplicationModal(), this.renderTransferModal());
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "consultant-interest"
      }, renderLogistics(interest.days_ago, true), this.renderInterestDetails(), /*#__PURE__*/React.createElement("div", {
        className: "mb-15"
      }, accepted && /*#__PURE__*/React.createElement("button", {
        id: "create-proposal",
        value: "Create Proposal",
        onClick: this.createNewProposal,
        className: "btn btn-secondary full-width"
      }, "Create Proposal")), this.renderInterestStatus(), this.renderApplicationModal(), this.renderTransferModal());
    }
  }]);
}(Component);
ConsultantInterest.propTypes = {
  interest: PropTypes.shape({
    accepted: PropTypes.bool.isRequired,
    rejected: PropTypes.bool.isRequired,
    waitlisted: PropTypes.bool.isRequired
  }),
  interestId: PropTypes.number,
  createProposalPath: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  acceptedCallback: PropTypes.func,
  rejectedCallback: PropTypes.func,
  waitlistedCallback: PropTypes.func,
  clorifyUrl: PropTypes.string,
  createdProposal: PropTypes.func,
  project: PropTypes.shape({}),
  showInProposalsTab: PropTypes.bool,
  projectsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  projectResourceId: PropTypes.string
};
ConsultantInterest.defaultProps = {
  acceptedCallback: function acceptedCallback() {
    return null;
  },
  waitlistedCallback: function waitlistedCallback() {
    return null;
  },
  clorifyUrl: '',
  showInProposalsTab: false,
  interestId: null,
  interest: {},
  projectsOptions: [],
  projectResourceId: ''
};
export default ConsultantInterest;